/**
 * GraphQL mutations for generating community prompts
 */

import { gql } from '@apollo/client';

export const GENERATE_COMMUNITY_PROMPTS = gql`
  mutation GenerateCommunityPrompts($communityId: ID!, $input: GenerateCommunityPromptsInput!) {
    generateCommunityPrompts(communityId: $communityId, input: $input) {
      version
      classificationFileName
      moderationFileName
      classification {
        fileName
        promptVersion
        isNew
      }
      moderation {
        fileName
        promptVersion
        isNew
      }
    }
  }
`;
